
export enum ActionType {
    SEARCH_REPOSITORIES = 'search_repositories',
    SEARCH_REPOSITORIES_SUCCESS = 'search_repositories_success',
    SEARCH_REPOSITORIES_ERROR = 'search_repositories_error',
    LOAD_NOMINATIONS = 'load_nominations',
    LOAD_NOMINATIONS_SUCCESS = 'load_nominations_success',
    LOAD_NOMINATIONS_ERROR = 'load_nominations_error',
}